import { render, staticRenderFns } from "./-Demonstration.vue?vue&type=template&id=273701f8&scoped=true&"
import script from "./-Demonstration.vue?vue&type=script&lang=js&"
export * from "./-Demonstration.vue?vue&type=script&lang=js&"
import style0 from "./-Demonstration.vue?vue&type=style&index=0&id=273701f8&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "273701f8",
  null
  
)

export default component.exports